import React from 'react'
import '../static/style/contact.css'
import GitHubIcon from '@mui/icons-material/GitHub';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

function Contact() {
  return (
    <div className='contact'>
        <div className='cotact_right'>
            <h1>What's Next?</h1>
            <h2>Get In Touch</h2>
            <p>Do you Have projects ? or maybe just you want to say hello ? i'd love to hear from you .</p>

 
        </div>
        <div className='form'>
            <form >

                <label for="fname">Email</label>
                <input type="mail" id="fname" name="firstname" placeholder="Your email.."/>

                <label for="lname">Object</label>
                <input type="text" id="lname" name="lastname" placeholder="object.."/>
                <label for="lname">Message</label>
                <textarea type="text" id="lname" name="lastname" placeholder="Your message.."></textarea>
                <input type="submit" value="Submit"/>

                </form>
            </div>
            <ul className='icons'>
                <li>
                    <a href="https://github.com/merwan32">
                        <GitHubIcon />
                    </a>
                </li>  
                <li>
                    <a href="https://www.linkedin.com/in/bekkar-merwan-9b6559247/?locale=en_US">
                        <LinkedInIcon />
                    </a>
                </li> 
                <li>
                    <a href="https://www.instagram.com/bk__mrwan/">
                        <InstagramIcon />
                    </a>
                </li> 
                <li>
                    <a href="https://web.facebook.com/mer.wan.37625">
                        <FacebookOutlinedIcon />
                    </a>
                </li> 
            </ul>
    </div>
  )
}

export default Contact
